import { TERMINAL_DEFAULT_TAX } from './form-terminal-tax-types';
import { showToast } from '../../toasts';

import { postTerminalTax } from '../../../routes/post-terminal-tax';

/**
 * Function call the api route to update the default terminal tax list
 * 
 * @param {string} terminalID the ID of the terminal the taxes are applied to
 */
export const addTerminalTax = async (terminalID: string) => {
  const taxList = document.querySelectorAll<HTMLElement>('[data-taxid]');
  const taxIdArray = Array.from(taxList).map(e => e.getAttribute('data-taxid')!);

  const awsData = {
    terminalID: terminalID,
    taxIdArray: taxIdArray.join(',')
  }

  try {
    const response = await postTerminalTax(awsData);
    showToast('aafp_toast', `${TERMINAL_DEFAULT_TAX.terminalName.value} tax has been updated`);
  } catch (error) {
    showToast('aafp_toast', 'Failed to update terminal tax. Please try again.');
  }
}